import { motion } from "framer-motion";
import { ArrowRight, MessageCircle } from "lucide-react";
import { MEDIA, whatsappLink, WA } from "@/data/content";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Hero() {
  return (
    <section id="home" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        poster={MEDIA.heroFallback}
      >
        <source src={MEDIA.heroVideo} type="video/mp4" />
      </video>

      <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/70 via-[#050505]/60 to-[#050505]" />
      <div className="absolute inset-0 bg-[#050505]/40" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-8 pt-28 pb-16 w-full">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <span className="inline-flex items-center gap-2 rounded-full border border-teal-light/30 bg-teal/10 px-4 py-1.5 text-xs uppercase tracking-[0.25em] text-teal-light">
            Fast Life Studio Agency
          </span>

          <h1 className="mt-6 font-display font-semibold text-3xl sm:text-4xl lg:text-6xl tracking-tight leading-[1.08] text-white text-shadow-cinematic uppercase">
            Facciamo lavorare i social per la tua attività:{" "}
            <span className="text-teal-light">più attenzione, più contatti, più clienti e più fatturato!</span>
          </h1>

          <p className="mt-6 text-base sm:text-lg text-slate-300 max-w-2xl leading-relaxed">
            Idee, script, riprese professionali, montaggio e sponsorizzazioni: pensiamo noi a tutto
            ciò che serve per costruire una presenza social riconoscibile e continuativa.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3">
            <button
              data-testid="hero-cta-lavori"
              onClick={() => scrollTo("#portfolio")}
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-teal-light px-7 py-3.5 text-sm font-semibold text-[#050505] hover:bg-white transition-colors"
            >
              Guarda i nostri lavori
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <a
              data-testid="hero-cta-fernando"
              href={whatsappLink(WA.fernando)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 bg-white/5 backdrop-blur px-7 py-3.5 text-sm font-semibold text-white hover:bg-white/10 transition-colors"
            >
              <MessageCircle size={18} />
              Parla con Fernando
            </a>
          </div>

          <p className="mt-6 text-sm text-slate-400 max-w-xl">
            Video professionali per Instagram, Facebook e TikTok dedicati ad attività, aziende e professionisti.
          </p>

          <p className="mt-8 font-accent text-sm uppercase tracking-[0.3em] text-slate-400">
            Non realizziamo semplici video.{" "}
            <span className="text-teal-light">Creiamo il cinema di strada.</span>
          </p>
        </motion.div>
      </div>
    </section>
  );
}
